module.exports = __webpack_public_path__ + "static/profilo1-bb8b3f0eaf8f1e763deb65d24aa0d5bd.jpg";